import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";

const Navbar = () => {
  const { language, toggleLanguage, t } = useLanguage();

  return (
    <motion.nav
      className="fixed w-full z-50 backdrop-blur-md border-b border-white/10"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto max-w-screen-xl px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <img src="/logo.png" alt="Stockity" className="h-8" />
              <div className="ml-2 flex flex-col leading-none text-left">
                <span className="text-white font-semibold text-xl">Stockity</span>
                <span className="text-[10px] text-gray-400">Unofficial</span>
              </div>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">

            <motion.a
              href="https://stockity1.id/auth?a=778ce754e42c#signup"
              className="inline-flex items-center justify-center rounded-full bg-gradient-to-r from-sky-500 via-cyan-400 to-emerald-400 px-8 py-3 text-sm font-semibold text-slate-950 shadow-[0_12px_40px_rgba(56,189,248,0.55)] transition hover:brightness-110 sm:text-base"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 20px 40px rgba(59, 130, 246, 0.4)"
              }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
            >
              {t('nav.signup')}
            </motion.a>
            <button
              onClick={toggleLanguage}
              className="text-white flex items-center"
            >
            </button>
          </div>

          {/* Mobile Right Buttons */}
          <div className="flex items-center space-x-4 md:hidden">
            <motion.a
              href="https://stockity1.id/auth?a=778ce754e42c#signup"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 text-white px-4 py-1.5 rounded-full text-lg font-medium hover:brightness-110 transition-all inline-block shadow-[0_10px_30px_rgba(56,189,248,0.4)]"
            >
              {t('nav.login')}
            </motion.a>
            <button
              onClick={toggleLanguage}
              className="text-white"
            >
              <img
                src={language === 'en' ? "/uk-flag.svg" : "/id-flag.svg"}
                alt="Language"
                className="w-6 h-6"
              />
            </button>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
